import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MetricsService } from 'src/app/core/services/metrics.service';
import {
  PhotoInfo,
  SICallTypes,
  SICallTypesDatabaseCode,
} from '../../../types/service-insight-types';

@Component({
    selector: 'photo-card',
    templateUrl: './photo-card.component.html',
    styleUrls: ['./photo-card.component.scss'],
    standalone: false
})
export class PhotoCardComponent {
  @Input() photo!: PhotoInfo;
  @Input() selected = false;
  @Input() callType!: SICallTypes;

  @Output() photoClick = new EventEmitter<void>();
  @Output() selectionChange = new EventEmitter<Event>();

  SICallTypes = SICallTypes;

  viewReportURL: string =
    'https://ecolab.lightning.force.com/lightning/r/WorkOrder/';
  serviceCallLabel: string = '';

  constructor(private _metricsService: MetricsService) {}

  ngOnInit() {
    this.serviceCallLabel = this.mapServiceCallKeyToUnit(
      this.photo.callReasonCode,
    );
  }

  /**
   * Given the database code of a service call, return the unit mapped to the SICallType.
   * The unit is just the non-plural form of the SICallType, e.g. 'Installation' for SICallTypes.Installations.
   * @param callTypeCode
   * @returns
   */
  public mapServiceCallKeyToUnit(callTypeCode: string): string {
    //Get SICallType given the database code
    let entry = Object.entries(SICallTypesDatabaseCode).find(
      ([key, value]) => value === callTypeCode,
    );
    let callType: SICallTypes =
      entry == undefined
        ? SICallTypes.UntrackedCalls
        : (entry[0] as SICallTypes);
    let callTypeUnit = this._metricsService.mapServiceCallKeyToUnit(callType);
    return callTypeUnit;
  }
}
